<template>
  <VueFullCalendar
    class='app-calendar'
    ref="fullCalendar"
    defaultView="dayGridMonth"
    :header="header"
    :plugins="calendarPlugins"
    :events="calendarEvents"
    :editable="true"
    :selectable="true"
    @eventClick="handleEventClick"
    @datesRender="handleDatesRender"
    time-zone="UTC"
    contentHeight="auto"
  />
</template>
<script>
import VueFullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
export default {
  name: 'FullCalendar',
  props: {
    // eslint-disable-next-line vue/require-valid-default-prop
    calendarEvents: { type: Array, default: [] },
    header: { type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default () {
        return {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        }
      }
    }
  },
  data () {
    return {
      calendarPlugins: [
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
        listPlugin
      ]
    }
  },
  components: {
    VueFullCalendar // make the <VueFullCalendar> tag available
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    handleEventClick: function (arg) {
      arg.jsEvent.preventDefault()
      // alert('date click! ' + arg.dateStr)
      if (arg.event) {
        this.$emit('getEventClickId', arg.event.id)
      }
    },
    handleDatesRender: function (info) {
      const calendarApi = this.$refs.fullCalendar.getApi()
      const currentDate = calendarApi.getDate()
      const month = currentDate.getMonth() + 1
      const year = currentDate.getFullYear()

      // Emit to parent or fetch data for this month
      this.$emit('viewMonthYearChanged', { month, year })
    }
  }
}
</script>

<style lang='scss'>
  .fc-event, .fc-event:hover{
    color: #ffffff !important;
  }
  @import '~@fullcalendar/core/main.css';
  @import '~@fullcalendar/daygrid/main.css';
  @import '~@fullcalendar/timegrid/main.css';
  @import '~@fullcalendar/list/main.min.css';
</style>
